/* ==========================================================================
   ATN Homepage V1.0 — Section 07: ATN Resources Grid
   Spec reference: 04_Section.docx §33

   - Analytics: each division fires its configured event on card / CTA click.
   - Mobile slider: prev / next buttons, optional loop, scroll-snap driven.
     Hover is CSS-only and already disabled on touch devices.
   ========================================================================== */

(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';

  function deviceType() {
    var w = window.innerWidth;
    if (w <= 749) return 'mobile';
    if (w <= 1100) return 'tablet';
    return 'desktop';
  }

  function sectionIdFrom(el) {
    var wrapper = el.closest('[id^="shopify-section-"]');
    return wrapper ? wrapper.id.replace('shopify-section-', '') : '';
  }

  function send(root, eventName, params) {
    if (root.dataset.analytics !== 'true' || !eventName) return;

    var payload = Object.assign(
      {
        device_type: deviceType(),
        section_id: sectionIdFrom(root),
        current_page: window.location.pathname
      },
      params || {}
    );

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    }
  }

  /* ---- Analytics ------------------------------------------------------- */

  function bindAnalytics(root) {
    if (root.dataset.analytics !== 'true') return;

    root.addEventListener('click', function (event) {
      var card = event.target.closest('[data-atn-resource-event]');
      if (!card) return;

      send(root, card.dataset.atnResourceEvent, {
        division_name: card.dataset.atnResourceName || '',
        destination_url: card.getAttribute('href') || '',
        interaction_method: event.target.closest('.atn-resource__cta') ? 'cta' : 'card'
      });
    });
  }

  /* ---- Mobile slider --------------------------------------------------- */

  function bindSlider(root) {
    if (root.dataset.mobileSlider !== 'true') return;

    var grid = root.querySelector('[data-atn-resources-grid]');
    var nav = root.querySelector('[data-atn-slider-nav]');
    var prevBtn = root.querySelector('[data-atn-slider-prev]');
    var nextBtn = root.querySelector('[data-atn-slider-next]');
    if (!grid || !nav || !prevBtn || !nextBtn) return;

    var loop = root.dataset.sliderLoop === 'true';
    var mql = window.matchMedia(MOBILE_QUERY);

    function cards() {
      return Array.prototype.slice.call(grid.querySelectorAll('.atn-resource'));
    }

    function currentIndex() {
      var list = cards();
      var scrollLeft = grid.scrollLeft;
      var closest = 0;
      var min = Infinity;
      list.forEach(function (card, i) {
        var diff = Math.abs(card.offsetLeft - scrollLeft);
        if (diff < min) {
          min = diff;
          closest = i;
        }
      });
      return closest;
    }

    function goTo(index) {
      var list = cards();
      if (!list.length) return;

      if (index < 0) index = loop ? list.length - 1 : 0;
      if (index > list.length - 1) index = loop ? 0 : list.length - 1;

      grid.scrollTo({ left: list[index].offsetLeft, behavior: 'smooth' });
      updateButtons(index);
    }

    function updateButtons(index) {
      if (loop) {
        prevBtn.disabled = false;
        nextBtn.disabled = false;
        return;
      }
      var list = cards();
      if (typeof index !== 'number') index = currentIndex();
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= list.length - 1;
    }

    prevBtn.addEventListener('click', function () {
      goTo(currentIndex() - 1);
    });
    nextBtn.addEventListener('click', function () {
      goTo(currentIndex() + 1);
    });

    var scrollTimer;
    grid.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          updateButtons(currentIndex());
        }, 90);
      },
      { passive: true }
    );

    function syncVisibility() {
      if (mql.matches) {
        nav.hidden = false;
        updateButtons(currentIndex());
      } else {
        nav.hidden = true;
      }
    }

    if (mql.addEventListener) {
      mql.addEventListener('change', syncVisibility);
    } else if (mql.addListener) {
      mql.addListener(syncVisibility);
    }

    syncVisibility();
  }

  /* ---- Boot ------------------------------------------------------------ */

  function bind(root) {
    if (root.dataset.atnResourcesBound === 'true') return;
    root.dataset.atnResourcesBound = 'true';
    bindAnalytics(root);
    bindSlider(root);
  }

  function init(scope) {
    (scope || document)
      .querySelectorAll('[data-atn-resources-root]')
      .forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();